import * as React from "react";

import type { DesignaliProps } from "../../types";

export const AiGame = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M11.27,6.78c-.06-.25-.26-.44-.51-.51l-2.17-.56c-.09-.03-.15-.12-.12-.22.02-.06.06-.11.12-.12l2.17-.56c.25-.06.44-.26.51-.51l.56-2.17c.03-.09.12-.15.22-.12.06.02.11.06.12.12l.56,2.17c.06.25.26.44.51.51l2.17.56c.09.03.15.12.12.22-.02.06-.06.11-.12.12l-2.17.56c-.25.06-.44.26-.51.51l-.56,2.17c-.03.09-.12.15-.22.12-.06-.02-.11-.06-.12-.12l-.56-2.17Z" />
        <line x1="6" y1="13.99" x2="10" y2="13.99" />
        <line x1="8" y1="11.99" x2="8" y2="15.99" />
        <line x1="15" y1="14.99" x2="15.01" y2="14.99" />
        <line x1="18" y1="12.99" x2="18.01" y2="12.99" />
        <path
          fill="none"
          d="M5.93,8.06c-1.71.32-3.04,1.73-3.23,3.52,0,.05,0,.1-.02.15-.08.67-.68,5.71-.68,7.26,0,1.66,1.34,3,3,3,1,0,1.5-.5,2-1l1.41-1.41c.37-.38.88-.59,1.41-.59h4.34c.53,0,1.04.21,1.41.59l1.41,1.41c.5.5,1,1,2,1,1.66,0,3-1.34,3-3,0-1.55-.6-6.58-.68-7.26,0-.05-.01-.1-.02-.15-.18-1.78-1.52-3.2-3.23-3.52"
        />
      </svg>
    );
  },
);

export default AiGame;
